import { render, staticRenderFns } from "./StepAddresses.vue?vue&type=template&id=0a80c8dc"
import script from "./StepAddresses.vue?vue&type=script&lang=js"
export * from "./StepAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports